import { BookingStatus, BookingStatusIcons, FreightMode, FreightModeIcon } from "@assets/constants";
class BookingUtilities {
  getBookingFreightModeIcon = (freightMode?: FreightMode) => {
    switch (freightMode) {
      case FreightMode.AI:
        return FreightModeIcon.AIR;
      case FreightMode.SH:
        return FreightModeIcon.SHIP;
      default:
        return undefined;
    }
  };

  getStatusIcon = (status: BookingStatus, freightMode?: FreightMode) => {
    switch (status) {
      case BookingStatus.ONHOLD:
        return BookingStatusIcons.inWaiting;
      case BookingStatus.BOOKED:
        return BookingStatusIcons.registered;
      case BookingStatus.PICKUP_REGISTERED:
        return BookingStatusIcons.registered;
      case BookingStatus.PICKUP_SCHEDULED:
        return BookingStatusIcons.registered;
      case BookingStatus.PICKUP_STARTED:
        return BookingStatusIcons.registered;
      case BookingStatus.PARTIALLY_PICKED_UP:
        return BookingStatusIcons.registered;
      case BookingStatus.PICKUP_COMPLETED:
        return BookingStatusIcons.registered;
      case BookingStatus.IN_WAREHOUSE_RECEPTION:
        return BookingStatusIcons.inAReceivingWarehouse;
      case BookingStatus.LOAD_ON_BOARD:
        return freightMode === FreightMode.AI
          ? BookingStatusIcons.inTransitFlight
          : BookingStatusIcons.inTransitSea;
      case BookingStatus.IN_TRANSIT:
        return freightMode === FreightMode.AI
          ? BookingStatusIcons.inTransitFlight
          : BookingStatusIcons.inTransitSea;
      case BookingStatus.DISCHARGED:
        return BookingStatusIcons.shipmentUnloadedFromShip;
      case BookingStatus.SHIPMENT_UNLOADED:
        return BookingStatusIcons.shipmentUnloadedFromShip;
      case BookingStatus.ARRIVED_IN_POD:
        return BookingStatusIcons.shipmentUnloadedFromShip;
      case BookingStatus.DELIVERY_BOOKED:
        return BookingStatusIcons.deliveryOrdered;
      case BookingStatus.BEING_PICKED_AT_WAREHOUSE:
        return BookingStatusIcons.readyForDelivery;
      case BookingStatus.READY_FOR_DELIVERY:
        return BookingStatusIcons.displacementInWarehouse;
      case BookingStatus.LOADED_ON_TRUCK:
        return BookingStatusIcons.loadedIntoCar;
      case BookingStatus.OUT_FOR_DELIVERY:
        return BookingStatusIcons.inDriving;
      case BookingStatus.DELIVERED_POD:
        return BookingStatusIcons.delivered;
      case BookingStatus.DELIVERED_TO_DOMESTIC_TRANSPORT:
        return BookingStatusIcons.delivered;
      case BookingStatus.DELIVERED_TO_WAREHOUSE:
        return BookingStatusIcons.delivered;
      case BookingStatus.PICKED_UP_BY_CUSTOMER:
        return BookingStatusIcons.delivered;
      case BookingStatus.DELIVERED:
        return BookingStatusIcons.delivered;
      case BookingStatus.CANCELED:
        return BookingStatusIcons.canceled;
      case BookingStatus.DELETED:
        return BookingStatusIcons.canceled;
      default:
        return BookingStatusIcons.registered;
    }
  };
}

export default new BookingUtilities();
